module.exports = __webpack_public_path__ + "static/img/rare-masterclasses.5c1b1cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/thumbs/rare-masterclasses.png
// module id = VD6G
// module chunks = 0